import { yupResolver } from '@hookform/resolvers/yup';
import { Box, Button, Typography } from '@mui/material';
import { FieldValues, useForm } from 'react-hook-form';
import { DynamicCsvService } from '../../../Component/Api/DynamicCsv/DynamicCsvService';
import { AppDatepicker } from '../../../Component/Common/Components/FormValidationInputs/AppDatepicker';
import { DynamicCsvRequest } from '../../../Component/Model/Dto/DynamicCsv';
import { IndividualSalariesTemplateSchema } from './IndividualSalariesTemplateValidation';
import { ImportSource } from '../../../Component/Model/Enum/ImportEnum';

interface IProps {
    closeTemplateModal: () => void;
    importSource?: ImportSource;
}
export const IndividualSalariesTemplateModal = ({ closeTemplateModal, importSource }: IProps) => {

    const isEEGroupImport = importSource == ImportSource.EE_GroupImport;
    const { control, handleSubmit } = useForm({
        mode: 'all',
        resolver: yupResolver(IndividualSalariesTemplateSchema)
    });

    const handleDownload = async (data: FieldValues) => {
        const request: DynamicCsvRequest = {
            salaryStart: data.salaryStart,
            salaryEnd: data.salaryEnd,
            onlyShowCTC: false,
            importSource: importSource
        }

        const result = await DynamicCsvService.GenerateCsv(request).catch((err) => { console.log(err) });
        if (result) {
            const csvData = new Blob([result.data], { type: 'text/csv' });
            const url = URL.createObjectURL(csvData);
            const link = document.createElement('a');
            link.href = url;
            link.download = isEEGroupImport ? 'EE_Group_Import_Template_Individual_Salary.csv' : 'IndividualSalary.csv';
            link.click();
        }
        closeTemplateModal();

    }
    return (
        <form onSubmit={handleSubmit(handleDownload)}>
            <Box mt={2} display="flex" flexDirection="column" alignItems="center">
                <Box m={2} display="flex" alignItems="center">
                    <AppDatepicker control={control} name="salaryStart" label="Salary Start Date" inputFormat='yyyy/MM/dd' />
                    <Typography variant="body1" sx={{ mx: 2 }}>
                        to
                    </Typography>
                    <AppDatepicker control={control} name="salaryEnd" label="Salary End Date" inputFormat='yyyy/MM/dd' />
                </Box>
                <Box mt={2}>
                    <Button variant="contained" type='submit'>
                        Download CSV
                    </Button>
                </Box>
            </Box>
        </form>
    )
}

